// Vendors
import React, { ReactElement } from 'react'
import { FieldError } from 'react-hook-form'
import InputMask, { Props as InputMaskProps } from 'react-input-mask'

// Styles
import {
  Input,
  FormLabel,
  InputProps,
  FormControl,
  FormErrorMessage,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Text,
} from '@chakra-ui/react'

// Interfaces
export type FieldMaskProps = InputProps &
  InputMaskProps & {
    name: string
    label?: string
    error?: FieldError
    inputLeftElement?: ReactElement
    inputRightElement?: ReactElement
    isRequired?: boolean
  }

const FieldMaskBase: React.ForwardRefRenderFunction<
  HTMLInputElement,
  FieldMaskProps
> = (props: FieldMaskProps, ref): JSX.Element => {
  /*
  |-----------------------------------------------------------------------------
  | Constants
  |-----------------------------------------------------------------------------
  |
  |
  */

  const {
    name,
    label,
    error,
    inputLeftElement,
    inputRightElement,
    isRequired,
    ...rest
  } = props

  /*
  |-----------------------------------------------------------------------------
  | Renders
  |-----------------------------------------------------------------------------
  |
  |
  */
  return (
    <FormControl isInvalid={!!error}>
      {!!label && (
        <FormLabel htmlFor={name}>
          {label}
          {isRequired && (
            <Text
              as="span"
              color="red.500"
              ml={1}
              fontWeight="bold"
              userSelect="none"
            >
              *
            </Text>
          )}
        </FormLabel>
      )}

      <InputGroup>
        {inputLeftElement && (
          <InputLeftElement h="auto" w="auto">
            {inputLeftElement}
          </InputLeftElement>
        )}

        <Input
          as={InputMask}
          id={name}
          ref={ref}
          name={name}
          _disabled={{
            opacity: 0.7,
            cursor: 'not-allowed',
          }}
          {...rest}
        />

        {inputRightElement && (
          <InputRightElement>{inputRightElement}</InputRightElement>
        )}
      </InputGroup>

      {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  )
}

export const FieldMask = React.forwardRef(FieldMaskBase)
